import Vue from 'vue';

declare global {
  interface Window {
    paypal: any;
  }
}

export const setupPaypalButton = async (clientId: string) => {
  await new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://www.paypal.com/sdk/js?client-id=${clientId}&locale=ja_JP&currency=JPY`;
    script.addEventListener('load', resolve);
    script.addEventListener('error', reject);
    document.body.appendChild(script);
  });

  const PayPalButton = window.paypal.Buttons.driver('vue', Vue);
  Vue.component('PayPalButton', PayPalButton);
};

export const isPaypalInstalled = () => {
  return !!window.paypal;
};
